import { render, staticRenderFns } from "./FieldsetPropertyGeneralData.yaml?vue&type=template&id=b680ac02&component"
import script from "./FieldsetPropertyGeneralData.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetPropertyGeneralData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports